import { ButtonLink, RepeatIcon } from '@razz-team/ui-web';
import { ApiTransaction } from '../../../openapi';
import { useTranslation } from 'react-i18next';

export function isTransactionRepeatable(transaction: ApiTransaction): boolean {
  return (
    transaction.direction === 'OUT' &&
    Boolean(transaction.counterparty.customer || transaction.counterparty.beneficiary)
  );
}

export function RepeatTransactionButton({ transaction }: { transaction: ApiTransaction }) {
  const { t } = useTranslation();

  return (
    <ButtonLink
      to="/account/transfer"
      search={{ transactionId: transaction.id, createdAt: transaction.date.created }}
      color="secondary"
      endIcon={<RepeatIcon />}
    >
      {t('Repeat')}
    </ButtonLink>
  );
}
